// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d18fae94","312":"7fcbfe85","453":"39352840","455":"8fe84b00","548":"434cb47f","678":"dba2eacd","755":"49cf534b","780":"120b5843","977":"f498cb29"}[chunkId] + ".chunk.js";
};